export default {
      id: "presence-away-usage",
      viewBox: "0 0 10 10",
      url: "/dist/svg/" + "sprite.svg#presence-away-usage",
      toString: function () {
        return this.url;
      }
    }